import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { ApiUrls } from '@api/apiUrls';
import { WarningIcon } from '@components-library/Icons/iconsComponents';
import { CONSTANTS } from '@components-shared/constants';
import { ConfirmDialog, NotificationDialog } from '@components-shared/modal';
import { NotificationMessage } from '@components-shared/notification';
import { ButtonPreloader } from '@components-shared/preloader';
import { keyMap } from '@locales/lokalise/keyMap';
import { fetchApi } from 'api/fetchApi';
import { connectToContext, IAppContext } from 'contextStore';
import { handleError } from 'utils/errors';
import styles from './styles.module.scss';

interface IAccountArchivingFormState {
  processing: boolean;
}

interface IAccountArchivingFormProps extends RouteComponentProps, IAppContext {
  accountId: string;
}

class AccountArchivingForm extends Component<IAccountArchivingFormProps, IAccountArchivingFormState> {
  constructor(props: IAccountArchivingFormProps) {
    super(props);
    this.state = {
      processing: false,
    };
  }

  archive = (): void => {
    const content = keyMap.tradingAccountsArchvingFormConfirmMessage;
    const action = async () => {
      await this.onArchive();
    };
    const closeAction = null;
    const needComment = false;
    const confirmBtnText = keyMap.modalConfirm;

    ConfirmDialog.show(content, action, closeAction, needComment, confirmBtnText);
  };

  onArchive = async (): Promise<void> => {
    const { history, accountId } = this.props;

    try {
      this.setState({ processing: true });
      await fetchApi.post(`${ApiUrls.tradingAccountUser.archive}?id=${accountId}`);

      NotificationDialog.show(keyMap.tradingAccountsArchvingFormSuccessMessage);
      history.push('/member');
    } catch (error) {
      handleError(keyMap.tradingAccountsArchvingFormErrorMessage, error);
      this.setState({ processing: false });
    }
  };

  render(): JSX.Element {
    const { i18next } = this.props;
    const { processing } = this.state;

    return (
      <div className="form-box__row">
        <div className="form-box">
          <div className={styles.accountArchivingForm__notification}>
            <NotificationMessage
              title={keyMap.tradingAccountsArchvingFormWarnigingMessageTitle}
              listItems={[
                keyMap.tradingAccountsArchvingFormWarnigingMessageUndoneAction,
                keyMap.tradingAccountsArchvingFormWarnigingMessageRestrictInformation,
              ]}
              useRollUp={false}
              type={CONSTANTS.NOTIFICATION_TYPE.WARNING}
              icon={<WarningIcon size="inherit" />}
            />
          </div>
          <button type="button" className="btn" onClick={this.archive}>
            {processing ? <ButtonPreloader /> : i18next.t(keyMap.sharedActionsArchive)}
          </button>
        </div>
      </div>
    );
  }
}

export default connectToContext(AccountArchivingForm);
